




































import {Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Debounce } from 'vue-debounce-decorator';

import { Element } from '@api/models/Element'
import { getParentTags, getSessionTypes } from "./data/sessionTypes"
import { TagsState } from '@service/store/types/TagsState';
import { Tag } from '@api/models/Tag';
import { TagsFilterState } from "@share/program/components/parallel-agendas/filter/TagsFilterState"
import { TagsType } from './data/filterType';

import AgendaFilterDateSwitcher from '@share/date-switcher/AgendaFilterDateSwitcher.vue'
import FilterButton from "@share/common/FilterButton.vue";
import TagList from "@share/common/tag-list/TagList.vue";
import FilterModal from "@share/participants-table/components/FilterModal.vue";
import { SelectableTag } from '@api/models/SelectableTag';
import SearchInput from "@share/common/search-input/SearchInput.vue";
import AgendaFilterTZ from "./AgendaFilterTZ.vue";
import { mainActions } from '@service/store/main/actions';
import { getBackend } from '@service/router/getters';

@Component({
    components: { TagList, AgendaFilterDateSwitcher, FilterModal, FilterButton, SearchInput, AgendaFilterTZ }
})
export default class AgendasFilter extends Vue {

    @Prop() agendas: Element[];
    @Prop() selectedTypes: string[];
    @Prop() selectedTagsIds: string[];
    @Prop() keyword: string;
    @Prop() type: string;
    @Prop() selectedTimeZone: string;

    showModal = false;

    date = null;

    sessionTypes = getSessionTypes();

    typeFilterState: TagsFilterState | null = null;
    tagsFilterState: TagsFilterState | null = null;

    datePickerSide = "";

    onTZChange(offset: string) {
        this.$store.dispatch(mainActions.setSelectedTimeZone, offset);

        this.$emit('filterTz', offset);
    }

    mounted() {

        this.typeFilterState = new TagsFilterState(this.sessionTypes, "filterType");
        this.tagsFilterState = new TagsFilterState(this.sessionSelectableTags, "filterTags");

        this.setDatePickerSide();

        this.watchAgendas();
        this.watchSessionTags();
    }

    @Debounce(40)
    setDatePickerSide() {
        // is this useless?
        this.datePickerSide = window.innerWidth >= 1024 ? 'right' : ''
    }

    activated() {
        window.addEventListener('resize', this.setDatePickerSide)
    }

    deactivated() {
        window.removeEventListener('resize', this.setDatePickerSide)
    }

    onSearchInput(keyword: string) {
        this.$emit("filterKeyword", keyword);
    }

    get searchPlaceholder() {
        return this.$t("agenda.searchByName").toString();
    }

    get parentTags() {
        return getParentTags()
            .filter(parentTag => (this.tagsForModal?.filter(tagForModal => tagForModal.tag.parentId === parentTag.id)?.length || 0) > 1)
    }

    get tagsForModal() {
        return this.typeFilterState?.tags?.concat(this.tagsFilterState?.tags || []);
    }

    get backend() {
        return getBackend(this.$route.params.backend)
    }

    get showTagsButtons() {
        return this.visibleSessionTypes.length > 1 || this.visibleTags.length > 1;
    }

    clearFilter() {
        this.typeFilterState?.clear();
        this.tagsFilterState?.clear();

        this.$emit('clear')
    }

    showFiltersModal() {

        this.showModal = true;

        this.typeFilterState?.setTags();
        this.tagsFilterState?.setTags();
    }

    applyFilters() {

        this.$emit(this.typeFilterState?.eventName || "", this.typeFilterState?.acumulatedTagsIds.map(item => item))
        this.$emit(this.tagsFilterState?.eventName || "", this.tagsFilterState?.acumulatedTagsIds.map(item => item))

        this.showModal = false;

        this.$nextTick(() => {
            this.watchAgendas();
            this.setTags();
        });
    }

    accumulateFilters(eventItem: SelectableTag) {
        if(eventItem.tag.parentId === TagsType.tags) {
            this.tagsFilterState?.accumulateTag(eventItem)
        }
        else {
            this.typeFilterState?.accumulateTag(eventItem)
        }
    }

    get visibleSessionTypes() {
        return this.typeFilterState?.sourceTags.filter((sessionType) => sessionType.isVisible) || [];
    }

    get visibleTags() {
        return this.tagsFilterState?.sourceTags.filter((sessionType) => sessionType.isVisible) || [];
    }

    get tagsState(): TagsState {
        return this.$store.state.tags;
    }

    get sessionTagsList(): Tag[] {
        return this.tagsState.sessionTags?.map((tag) => new Tag({
            ...tag,
            parentId: TagsType.tags
        })) || [];
    }

    get sessionSelectableTags() {
        return this.sessionTagsList
            .filter((tag) => this.existingTagsIds.has(tag.id))
            .map((tag) => {
                return {
                    tag: tag,
                    isVisible: true,
                    isSelected: this.selectedTagsIds.includes(tag.id)
                }
            })
    }

    get existingTagsIds(): Set<string> {
        return new Set(this.agendas.map(agenda => agenda.tagsIds).flat())
    }

    resetFilters() {

        this.typeFilterState?.clear();
        this.tagsFilterState?.clear();

        this.applyFilters();
    }

    @Watch("existingTagsIds")
    @Watch("sessionTagsList")
    watchSessionTags() {
        this.setTags();
    }

    @Watch('agendas')
    watchAgendas() {
        //если в списке сессий встречаются более одного разного типа, то показывать все найденные типы

        const types = new Set(this.agendas.map(agenda => agenda.type))

        this.typeFilterState?.updateSource(this.sessionTypes, types, this.selectedTypes);
    }

    setTags() {
        this.tagsFilterState?.updateSource(this.sessionSelectableTags, this.existingTagsIds, this.selectedTagsIds);
    }
}

